module.exports = __webpack_public_path__ + "img/checked.4ef00252.png";